export default __webpack_public_path__ + "static/media/opening-3.7a9a39db.jpg";